import { render } from "./viewChats.html?vue&type=template&id=f3d6e3d8&scoped=true&ts=true&external"
import script from "./ViewChats.vue?vue&type=script&lang=ts"
export * from "./ViewChats.vue?vue&type=script&lang=ts"

import "./ViewChats.vue?vue&type=style&index=0&id=f3d6e3d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d6e3d8"]])

export default __exports__